import Cookies from 'js-cookie'
import * as types from './mutation-types'

//const { locale, locales } = 'en'

const initialState = 
     { locale : Cookies.get('locale') || 'en', locales : Cookies.get('locale') || 'en'}
    
export const lang = {
    namespaced: true,
        state:  initialState 
        ,
        getters:{
            locale: state => state.locale,
            locales: state => state.locales
        },
        actions: {
            setLocale ({ commit }, { locale }) {
                commit(types.SET_LOCALE, { locale })
            
                Cookies.set('locale', locale, { expires: 365 })
            }
        },
        mutations: {
            [types.SET_LOCALE] (state, { locale }) {
                state.locale = locale
        }
    }
}